import { createAction } from "redux-starter-kit";

import {
  FETCH_FREEZEEVENTS_FAILURE,
  FETCH_FREEZEEVENTS_REQUEST,
  FETCH_FREEZEEVENTS_SUCCESS
} from "../types";

const fetchFreezeEvents = factoringId => async (
  dispatch,
  getState,
  { api }
) => {
  try {
    dispatch(createAction(FETCH_FREEZEEVENTS_REQUEST)());
    const response = await api.factoring.getFreezeEvents(factoringId);
    dispatch(
      createAction(FETCH_FREEZEEVENTS_SUCCESS)({
        factoringId,
        results: response.results,
        next: response.next,
        append: false
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_FREEZEEVENTS_FAILURE)(err));
    throw err;
  }
};

export default fetchFreezeEvents;
